import { render, staticRenderFns } from "./measurementComment.vue?vue&type=template&id=a1daede4&"
import script from "./measurementComment.vue?vue&type=script&lang=js&"
export * from "./measurementComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports